module.exports = __webpack_public_path__ + "img/1563062849.a862d34e.jpg";